export default __webpack_public_path__ + "static/media/Vector1.44433127.svg";